const VendorRatingCard = ({ rating }) => {
  const isEligible =
    rating &&
    rating.status === "COMPLETION_ACCEPTED" &&
    rating.score !== null &&
    rating.score !== undefined;

  return (
    <section>
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl font-bold text-gray-900">Vendor rating for this job</h2>
      </div>

      <div className="bg-white border border-gray-100 shadow-sm rounded-lg p-5">
        {!isEligible ? (
          <div className="text-sm text-gray-500">
            Job must have completion accepted status before it can be rated.
          </div>
        ) : (
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <span
                  key={star}
                  className={`text-xl ${
                    star <= rating.score ? "text-amber-400" : "text-gray-300"
                  }`}
                >
                  ★
                </span>
              ))}
              <span className="text-sm text-gray-600">({rating.score}/5)</span>
            </div>
            {rating.comment && (
              <div className="text-sm text-gray-700 border border-gray-200 rounded-md p-3 bg-gray-50">
                {rating.comment}
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default VendorRatingCard;
